export default __webpack_public_path__ + "static/media/Image-16.ed676656.png";